<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 292"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">称重记录</span>
            <el-divider direction="vertical" v-if="!weightDisable"></el-divider>
            <b-button
              size="sm"
              v-if="!weightDisable"
              variant="outline-success"
              @click="
                openEditFormDialog({
                  type: 'add',
                  code: '',
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增称重
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
            v-if="!weightDisable"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditFormDialog({
                  type: 'edit',
                  code: row.waybillWeightCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-if="!weightDisable"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看"
            placement="top"
            v-if="weightDisable"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditFormDialog({
                  type: 'detail',
                  code: row.waybillWeightCode,
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    weightDisable: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  methods: {
    openEditFormDialog(params) {
      this.$emit('openEditFormDialog', params)
    },
    del(row) {
      let msg = '是否删除该条称重记录？'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .bizWaybillWeightDelApi({
            waybillWeightCode: row.waybillWeightCode,
            waybillCode: row.waybillCode,
          })
          .then((res) => {
            this.$message.success(res.msg)
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
